import { Box, List, ListItemButton, ListProps, Typography } from '@mui/material';
import React from 'react';
import { Loader } from '../Loader';


export type AsyncListProps<T> = ListProps & {
  loading?: boolean;
  options: T[];
  renderItem: (opt: T) => React.ReactElement;
  setValue?: (opt: T) => void;
  noResultsMessage?: string;
};


export const AsyncList = <T extends { id: string }>({ loading, options, renderItem, setValue, noResultsMessage, ...props }: AsyncListProps<T>) => {
  if (loading) {
    return (
      <List>
        <Loader height="40px" width="100%" thickness={5} size={20} color="primary" />
      </List>
    );
  }

  if (options.length < 1) {
    return (
      <List>
        <Box height="40px" width="100%" display="flex" alignItems="center" justifyContent="center">
          <Typography color="textSecondary">{noResultsMessage ?? 'No results'}</Typography>
        </Box>
      </List>
    );
  }

  return (
    <List {...props}>
      {options.map(opt => (
        <ListItemButton key={opt.id} onClick={() => setValue?.(opt)}>
          {renderItem(opt)}
        </ListItemButton>
      )
      )}
    </List>
  );
};
